export default "__VITE_ASSET__vXLRvrrT__"